import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TenantProvider } from '@/app/providers/TenantProvider';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { AppRouter } from '@/app/router/AppRouter';

/**
 * App — root component.
 *
 * Provider hierarchy mirrors Flutter's MultiProvider in appInitializer():
 *   1. QueryClientProvider (data fetching)
 *   2. TenantProvider (workspace resolution, theme, content, config)
 *   3. AuthProvider (Firebase auth state)
 *   4. AppRouter (React Router)
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Flutter never retries a failed request
      retry: false,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TenantProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </TenantProvider>
    </QueryClientProvider>
  );
}
